import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
type BeforeAfterColumnsProps = {
  beforeTitle: string;
  afterTitle: string;
  before: string[];
  after: string[];
};
export function BeforeAfterColumns({
  beforeTitle,
  afterTitle,
  before,
  after
}: BeforeAfterColumnsProps) {
  return <div className="grid gap-5 md:grid-cols-2" data-id="element-20" data-mp="2lajnwihkxkw4">
      <div className="rounded-3xl border border-red-200 bg-red-50 p-6 sm:p-8" data-id="element-21" data-mp="2l8p271yhhoqz">
        <h3 className="flex items-center gap-2.5 text-lg font-extrabold uppercase tracking-wide text-red-700" data-id="element-22" data-mp="2z8qbn5ste4i2">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-23" data-mp="2v7y18987htk7">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-24" data-mp="38z2tgq98vjki" />
          </span>
          {beforeTitle}
        </h3>
        <ul className="mt-5 space-y-3.5" data-id="element-25" data-mp="342ujdr9wmgk7">
          {before.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-ink/80" data-id="element-26" data-mp="3iyjwezx43jcs">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-27" data-mp="3e0ih8q2t446l" />
              {item}
            </li>)}
        </ul>
      </div>
      <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-6 sm:p-8" data-id="element-28" data-mp="1qv0z9yprs9la">
        <h3 className="flex items-center gap-2.5 text-lg font-extrabold uppercase tracking-wide text-emerald-800" data-id="element-29" data-mp="1uxe4mm0lu5hj">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cta text-white" data-id="element-30" data-mp="1zwh6xyp79xlt">
            <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="24w3i82lgx3rz" />
          </span>
          {afterTitle}
        </h3>
        <ul className="mt-5 space-y-3.5" data-id="element-32" data-mp="29t3q8j1voglq">
          {after.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug text-ink" data-id="element-33" data-mp="2ekv721v8f7yo">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-34" data-mp="2ilnjt53bbuzp" />
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}